<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead class="text-center">
                    <tr>
                        <th class="text-left" style="width:75px;max-width:75px">Nama</th>
                        <th class="text-left" style="width:75px;max-width:75px">Jabatan</th>
                        <th class="text-left" style="width:50px;max-width:50px">Tanggal</th>
                        <th class="text-left" style="width:75px;max-width:75px;">No. Reimburse</th>
                        <th class="text-left" style="width:75px;max-width:75px">Status</th>
                        <th class="text-left" style="width:75px;max-width:75px">Total Pengajuan</th>
                        <th class="text-left" style="width:25px;max-width:25px">File</th>
                        <th class="text-left" style="width:50px;max-width:50px">Action</th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="8">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td style="width:75px;max-width:75px">{{body.namaPegawai}}</td>
                                    <td style="width:75px;max-width:75px" :title="body.jabatan">{{body.jabatan}}</td>
                                    <td style="width:50px;max-width:50px;padding-left:10px;padding-right:10px;">{{separatorTanggal(body.createdDate)}}</td>
                                    <td style="width:75px;max-width:75px">{{body.noReimburse}}</td>
                                    <td style="width:75px;max-width:75px" :title="body.keteranganStatus">
                                        <span class="font-weight-bold" :style="{ color : body['color'] }">{{body.keteranganStatus}}</span>
                                    </td>
                                    <td style="width:75px;max-width:75px"><span style="float:right">{{separatorRupiah(body.totalPengajuan)}}</span></td>
                                    <td style="width:25px;max-width:25px">
                                        <CRow>
                                            <CCol sm="6" v-for="(bodys, id) in body.daftarUrlFile" :key="id">
                                                <img :src="downloadIcon" @click="direct(bodys)" width="20px" height="20px" style="cursor:pointer"/>
                                            </CCol>
                                        </CRow>
                                    </td>
                                    <td style="width:50px;max-width:50px">
                                        <span class="text-center">
                                            <CButton @click="goEdit(id)" class="btn btn-edit" v-if="data[id].status == 'W'">Edit</CButton>
                                            <CButton @click="detailPeserta(id)" class="btn btn-edit" v-if="data[id].status != 'W'">Result</CButton>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead class="text-center">
                            <tr>
                                <th class="text-left">Nama</th>
                                <th class="text-left">Jabatan</th>
                                <th class="text-left">Tanggal</th>
                                <th class="text-left">No. Reimburse</th>
                                <th class="text-left">Status</th>
                                <th class="text-left">Total Pengajuan</th>
                                <th class="text-left">File</th>
                                <th class="text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="8">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td>{{body.namaPegawai}}</td>
                                <td :title="body.jabatan">{{body.jabatan}}</td>
                                <td style="padding-left:10px;padding-right:10px;">{{separatorTanggal(body.createdDate)}}</td>
                                <td>{{body.noReimburse}}</td>
                                <td :title="body.keteranganStatus">
                                    <span class="font-weight-bold" :style="{ color : body['color'] }">{{body.keteranganStatus}}</span>
                                </td>
                                <td><span style="float:right">{{separatorRupiah(body.totalPengajuan)}}</span></td>
                                <td>
                                    <CRow>
                                        <CCol sm="6" v-for="(bodys, id) in body.daftarUrlFile" :key="id">
                                            <img :src="downloadIcon" @click="direct(bodys)" width="20px" height="20px" style="cursor:pointer"/>
                                        </CCol>
                                    </CRow>
                                </td>
                                <td>
                                    <span class="text-center">
                                        <CButton @click="goEdit(id)" class="btn btn-edit" v-if="data[id].status == 'W'">Edit</CButton>
                                        <CButton @click="detailPeserta(id)" class="btn btn-edit" v-if="data[id].status != 'W'">Result</CButton>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="detailModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Detail Daftar Peserta Reimburse</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="detailModal = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="3">
                        Nama
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{dataNama}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="3">
                        Jabatan
                    </CCol>
                    <CCol sm="9">
                        : {{dataJabatan}}
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="3">
                        Tanggal Pengajuan
                    </CCol>
                    <CCol sm="9">
                        : {{separatorTanggal(dataTanggal)}}
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="3">
                        No Kartu
                    </CCol>
                    <CCol sm="9">
                        : {{dataNoKartu}}
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="3">
                        No Reimburse
                    </CCol>
                    <CCol sm="9">
                        : {{dataNoReimburs}}
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="3">
                        Total Pengajuan
                    </CCol>
                    <CCol sm="9">
                        : <span>{{separatorRupiah(dataTotalPengajuan)}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1" v-if="dataStatus == 'B'">
                    <CCol sm="3">
                        Total Dibayarkan
                    </CCol>
                    <CCol sm="9">
                        : <span>{{separatorRupiah(dataTotalApprove)}}</span>
                    </CCol>
                </CRow>      
                <CRow class="mt-1" v-if="dataStatus == 'B'">
                    <CCol sm="3">
                        Tanggal Dibayarkan
                    </CCol>
                    <CCol sm="9">
                        : <span>{{separatorTanggal(dataTanggalDibayarkan)}}</span>
                    </CCol>
                </CRow>                
                <CRow class="mt-1">
                    <CCol sm="3">
                        Status
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold" :style="{ color : dataColor }">{{dataKeteranganStatus}}</span>
                    </CCol>
                </CRow>
                <CRow v-if="dataStatus == 'R' || dataStatus == 'P' || dataStatus == 'B'" class="mt-1">
                    <CCol sm="3">
                        Keterangan
                    </CCol>
                    <CCol sm="9">
                        : <span>{{dataKeterangan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-1">
                    <CCol sm="3">
                        Kloter
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{dataNamaKloter}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="12">
                        <span class="font-weight-bold">Peserta </span>
                        <table>
                            <thead>
                                <tr>
                                    <th style="white-space:normal;word-wrap: break-word">Nama</th>
                                    <th style="white-space:normal;word-wrap: break-word">Diagnosa</th>
                                    <th style="white-space:normal;word-wrap: break-word">Tgl Kwitansi</th>
                                    <th style="white-space:normal;word-wrap: break-word">Biaya</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(body, ids) in dataPeserta" :key="ids">
                                    <td style="white-space:normal;word-wrap: break-word">{{body.nama}}</td>
                                    <td style="white-space:normal;word-wrap: break-word">{{body.diagnosa}}</td>
                                    <td style="white-space:normal;word-wrap: break-word">{{separatorTanggal(body.tanggalKwitansi)}}</td>
                                    <td style="white-space:normal;word-wrap: break-word"><span style="float:right">{{separatorRupiah(body.biaya)}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol class="text-right" sm="12">
                    <CButton @click="detailModal = false" class="modal-button-cancel">Back</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
export default {
    props: ['data', 'errors'],
    data() {
        return {
            detailModal: false,
            dataPeserta: [],
            dataNama: '',
            dataJabatan: '',
            dataTanggal: '',
            dataTanggalDibayarkan: '',
            dataNoKartu: '',
            dataNoReimburs: '',
            dataKeterangan: '',
            dataTotalApprove: '',
            dataTotalPengajuan: '',
            dataColor: '',
            dataStatus: '',
            dataNamaKloter: '',
            dataKeteranganStatus: '',
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
            closeIcon: require('@/assets/menu/icon_close.svg'),
            downloadIcon: require('@/assets/menu/icon_download_excel.svg'),
        }
    },
    mounted() {
    },
    watch: {

    },
    methods: {
        goEdit(id) {
            this.$emit('edit', id)
        },
        detailPeserta(value) {
            this.dataPeserta = this.data[value].daftarPeserta
            this.dataNama = this.data[value].namaPegawai
            this.dataJabatan = this.data[value].jabatan
            this.dataTanggal = this.data[value].createdDate
            this.dataKeterangan = this.data[value].keteranganApprove
            this.dataNoKartu = this.data[value].noKartuPeserta
            this.dataNoReimburs = this.data[value].noReimburse
            this.dataTotalApprove = this.data[value].totalApprove
            this.dataTotalPengajuan = this.data[value].totalPengajuan
            this.dataStatus = this.data[value].status
            this.dataKeteranganStatus = this.data[value].keteranganStatus
            this.dataNamaKloter = this.data[value].kloter
            this.dataColor = this.data[value].color
            this.dataTanggalDibayarkan = this.data[value].tanggalBayar
            this.detailModal = true
        },
        separatorTanggal(val) {
            let tanggal = val.split("-")[2]
            let bulanTemp = val.split("-")[1]
            let tahun = val.split("-")[0]
            let bulan = ''
            if(bulanTemp == '01' || bulanTemp == '1') {
                bulan = 'Jan'
            } else if(bulanTemp == '02' || bulanTemp == '2') {
                bulan = 'Feb'
            } else if(bulanTemp == '03' || bulanTemp == '3') {
                bulan = 'Mar'
            } else if(bulanTemp == '04' || bulanTemp == '4') {
                bulan = 'Apr'
            } else if(bulanTemp == '05' || bulanTemp == '5') {
                bulan = 'Mei'
            } else if(bulanTemp == '06' || bulanTemp == '6') {
                bulan = 'Jun'
            } else if(bulanTemp == '07' || bulanTemp == '7') {
                bulan = 'Jul'
            } else if(bulanTemp == '08' || bulanTemp == '8') {
                bulan = 'Agu'
            } else if(bulanTemp == '09' || bulanTemp == '9') {
                bulan = 'Sep'
            } else if(bulanTemp == '10') {
                bulan = 'Okt'
            } else if(bulanTemp == '11') {
                bulan = 'Nov'
            } else if(bulanTemp == '12') {
                bulan = 'Des'
            }
            return tanggal + ' ' + bulan + ' ' + tahun
        },
        separatorRupiah(val) {
            if(val == 'null') {
                val = '0'
            }
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return 'Rp. ' + rupiah 
        },
        direct(link) {
            window.open(
            link,
            '_blank' // <- This is what makes it open in a new window.
            );
        },       
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>
